export const loaderStatus = {
  NOT_STARTED: 'notStarted',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  CANCELED: 'canceled'
} as const

export const loaderHandler = {
  statusChange: 'handleStatusChange',
  loading: 'handlLoading',
  success: 'handleSuccess',
  error: 'handleError',
  canceled: 'handleCanceled',
  complete: 'handleComplete',
  progress: 'handleProgress'
} as const
